module.exports = __webpack_public_path__ + "static/media/ez-coder.b7106186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/web-development/ez-coder.png
// module id = 174
// module chunks = 0